import { render, staticRenderFns } from "./LandfillDetailPage.vue?vue&type=template&id=5c8bcbbc&scoped=true"
import script from "./LandfillDetailPage.vue?vue&type=script&lang=js"
export * from "./LandfillDetailPage.vue?vue&type=script&lang=js"
import style0 from "./LandfillDetailPage.vue?vue&type=style&index=0&id=5c8bcbbc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8bcbbc",
  null
  
)

export default component.exports